import React, {Fragment, useState} from 'react';
import {GeoJSON, LayerGroup, Popup, Tooltip} from "react-leaflet";
import {useDispatch, useSelector} from "react-redux";
import {PHARMACY, BAKERY, SUPERMARKET} from "../../../../../data/booking/constants/map_filters_type";
import {BakeryMarker, PharmacyMarker, SupermarketMarker} from "./Marker";
import {moseOverHike as moseOver} from "../../../../../data/booking/actions/map";
import {isEmpty} from "lodash";
import KmlLayer from "../../../../booking/components/map/leaflet/KmlLayer";

function ThemeLayer() {

    const filters = useSelector(state => state.booking.map.filters)
    const kmlData = useSelector(state => state.booking.map.kmlData)
    const dispatch = useDispatch()

    const theme = useSelector(state => state.booking.map.theme)
    const moseOverHike = useSelector(state => state.booking.map.moseOverHike)
    const hike = useSelector(state => state.booking.map.hike)
    const hikes = useSelector(state => state.booking.map.entities.hikes)

    return <LayerGroup>
            {theme && !isEmpty(theme.hikes) && theme.hikes.map(hikeId => {
                const themeHike = hikes[hikeId]
            if(kmlData[themeHike.id]
                && (!hike || themeHike.id != hike.id)
            ){

                const { LineString, Point } = kmlData[themeHike.id];

                return <Fragment key={themeHike.id}>
                    {LineString && (!moseOverHike || themeHike.id != moseOverHike.id ?
                        <>
                            <GeoJSON
                                data={{features: LineString}}
                                pathOptions={{
                                    color: '#830707',
                                    weight: 3,
                                }}
                                eventHandlers={{
                                    add: (e) => e.target.bringToBack(),
                                    mouseover: (e) => {
                                        dispatch(moseOver(themeHike))
                                    }
                                }} />
                            <GeoJSON
                                data={{features: LineString}}
                                pathOptions={{
                                    color: 'white',
                                    weight: 5,
                                }}
                                eventHandlers={{
                                    add: (e) => e.target.bringToBack(),
                                    mouseover: (e) => {
                                        dispatch(moseOver(themeHike))
                                    }
                                }} />
                        </> :
                        <GeoJSON
                            data={{features: LineString}}
                            pathOptions={{
                                color: '#ce1212',
                                weight: 4,
                            }}
                            eventHandlers={{
                                mouseover: (e) => {
                                    if(e.target.getTooltip()){
                                        e.target.getTooltip().setLatLng(e.latlng)
                                    }
                                },
                                mouseout: (e)=> {
                                    dispatch(moseOver(null))
                                },
                            }}>
                            <Tooltip>{themeHike.title}</Tooltip>
                        </GeoJSON>)
                    }
                    {Point && Object.keys(Point).map((type,i)=>{
                        if(filters.includes(type)){
                            return Point[type].map((point,j) => {
                                let popup = <Popup>{point.properties.name}</Popup>
                                switch (type) {
                                    case PHARMACY :
                                        return <PharmacyMarker position={[point.properties.latitude, point.properties.longitude]} key={point.properties.name+i+j} >{popup}</PharmacyMarker>
                                    case BAKERY :
                                        return <BakeryMarker position={[point.properties.latitude, point.properties.longitude]} key={point.properties.name+i+j} >{popup}</BakeryMarker>
                                    case SUPERMARKET :
                                        return <SupermarketMarker position={[point.properties.latitude, point.properties.longitude]} key={point.properties.name+i+j} >{popup}</SupermarketMarker>
                                }
                            })
                        }
                    })}
                </Fragment>
            } else if(hike && themeHike.id == hike.id && kmlData[hike.id]){
                return <KmlLayer key={hike.id} kmlData={kmlData[hike.id]} />
            }
        })}
        </LayerGroup>
}
export default ThemeLayer;